module.exports = __webpack_public_path__ + "img/eg-6.4cb1477c.jpg";